'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentPaylibAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M30.0675 22.9112L30.0465 22.0545L32.4 22.0763L32.4194 34.154H29.5757L29.5802 33.4958C28.9005 33.9397 28.0067 34.1496 26.817 34.1496C25.176 34.1496 23.9891 33.7629 23.188 32.9674C22.2736 32.0599 21.8526 30.6176 21.8619 28.4269L21.8664 27.3853C21.8842 23.4703 23.269 21.8733 26.6454 21.8733C28.1585 21.8733 29.2495 22.1999 30.0675 22.9112ZM25.3606 31.368C25.7079 31.7132 26.2601 31.8735 27.0972 31.8735C28.8415 31.8735 29.5883 31.196 29.5936 29.6082L29.6041 26.4601C29.6069 25.605 29.4466 25.0464 29.0989 24.7024C28.739 24.3459 28.1173 24.1732 27.1996 24.1732C25.2477 24.1732 24.7097 24.9187 24.6984 27.6423L24.6947 28.4059C24.6882 30.0126 24.887 30.8983 25.3606 31.368Z",
          fill: "#16D6FF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M43.8885 22.0739H41.0971L41.0873 29.8869C41.0853 30.7098 40.9675 31.1118 40.6514 31.372C40.2875 31.6741 39.7357 31.8154 38.9132 31.8154C38.1028 31.8154 37.5648 31.6906 37.2211 31.4247C36.9001 31.1746 36.7702 30.742 36.7722 29.9325L36.7936 22.0739H33.9746L33.988 30.2337C33.9844 31.6467 34.4317 32.646 35.3554 33.2864C36.2164 33.8966 37.2604 34.1455 38.9565 34.1455C39.79 34.1455 40.4903 34.0742 41.0845 33.9296L41.0979 34.9728C41.0958 35.8158 40.9667 35.987 40.3255 35.987H39.0528V38.3098H40.7858C42.9798 38.3098 43.8764 37.4499 43.8808 35.3418L43.8885 22.0739Z",
          fill: "#16D6FF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.0373 31.8002L14.0418 34.158C14.0418 34.158 15.6877 34.1612 15.7541 34.1612C19.2103 34.1612 20.6922 32.4647 20.71 28.4869L20.7149 27.4457C20.7254 25.2901 20.3162 23.8763 19.4276 22.9958C18.6622 22.2386 17.5538 21.8854 15.9403 21.8854C14.4393 21.8854 13.3063 22.2261 12.4922 22.9241L12.4854 22.0912L10.1379 22.0759L10.1663 38.3094H13.01L13.0116 26.5201C13.0221 24.7963 13.6443 24.1848 15.4618 24.1848C16.3249 24.1848 16.8875 24.3447 17.2352 24.6887C17.6963 25.1455 17.8898 26.0183 17.8817 27.6052L17.8785 28.3689C17.8659 31.0925 17.2996 31.7929 15.3958 31.7969L14.0373 31.8002Z",
          fill: "#16D6FF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M64.0929 29.702V14.9317C70.4669 16.416 75.2155 22.104 75.2151 28.8993C75.2151 36.8239 68.7594 43.2478 60.7958 43.2478C60.3323 43.2478 59.8741 43.2236 59.422 43.1814V26.3388H56.4447V42.5816C50.6063 40.7458 46.3733 35.3143 46.3733 28.8993C46.3733 25.3838 47.646 22.1648 49.7558 19.6696V30.9691C49.753 32.1034 49.9841 32.8714 50.4893 33.385C51.0058 33.9094 51.7968 34.1543 52.9788 34.1543L54.7231 34.1547C54.7231 34.1547 54.7231 33.9279 54.7247 33.4619L54.7271 32.4103V31.6974H53.3702C53.0768 31.6974 52.8889 31.6506 52.7946 31.5556C52.6768 31.4359 52.6278 31.1641 52.629 30.6723V17.0737C54.9514 15.4831 57.7639 14.5503 60.7958 14.5503C60.917 14.5503 61.0367 14.5544 61.1566 14.5584C61.1921 14.5597 61.2277 14.5609 61.2634 14.562V29.8454C61.2605 31.2885 61.5949 32.3301 62.3005 33.0293C63.1076 33.8297 64.3597 34.1869 66.3598 34.1869C70.1904 34.1869 71.8258 32.4759 71.831 28.4647L71.833 27.5318C71.8351 25.4039 71.4141 24.1376 70.5049 23.239C69.7439 22.487 68.6307 22.1036 67.1058 22.079L67.1054 22.0806L65.2008 22.079V24.4687H66.9034C67.6134 24.5146 68.0684 24.6781 68.3684 24.9887C68.7995 25.4354 68.9821 26.1177 68.9792 27.6075L68.9784 28.3543C68.9748 31.5435 68.1482 31.8923 66.3954 31.8923C65.4219 31.8923 64.8879 31.7517 64.5548 31.4206C64.2342 31.1028 64.0909 30.5563 64.0929 29.702ZM58.0293 25.3347C59.0388 25.3347 59.6185 24.7772 59.6226 23.8041H59.6221V23.647C59.623 23.1633 59.4825 22.7778 59.204 22.5027C58.921 22.2232 58.5033 22.075 57.9961 22.075H57.8775C56.8675 22.075 56.2631 22.6465 56.2607 23.6051L56.2599 23.7622C56.2587 24.2347 56.4008 24.6141 56.6821 24.8916C56.9744 25.1816 57.3982 25.3347 57.9103 25.3347H58.0293Z",
          fill: "#16D6FF"
        }
      )
    ]
  }
);
const VpPaymentPaylibAsset = forwardRef(PaymentPaylibAsset);

export { VpPaymentPaylibAsset as default };
